module.exports = __webpack_public_path__ + "img/fire_grey_al.d14853bd.svg";